import { ChangeDetectionStrategy, Component, inject, InjectionToken, type TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

export interface TooltipData {
  focus: () => void;
  blur: () => void;
  template?: TemplateRef<void>;
  text?: string;
}
export const TOOLTIP_DATA = new InjectionToken<TooltipData>('Tooltip data');

@Component({
  selector: 'tess-tooltip',
  imports: [NgTemplateOutlet],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(mouseenter)': 'focus()',
    '(mouseleave)': 'blur()',
  },
})
export class TooltipComponent {
  readonly data = inject<TooltipData>(TOOLTIP_DATA);

  focus(): void {
    this.data.focus();
  }

  blur(): void {
    this.data.blur();
  }
}
